import React, { useState } from "react";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Page from "../Components/Page";
import LoginForm from "../features/auth/LoginForm";
import { useTranslation } from "react-i18next";

export default function Login() {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { t } = useTranslation();
  return (
    <Page title={t("Login")} isLoading={isSubmitting}>
      <LoginForm onSubmit={(isSubmitting) => setIsSubmitting(isSubmitting)} />
      <Typography>{t("Forgot Your Password?")}</Typography>
      <Link to="/request_password_reset">{t("Click to Reset It")}</Link>
    </Page>
  );
}
